import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import AccountPopover from '../header/AccountPopover';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
    const { user } = useAuthContext();

    return (
        <StyledRoot>
            <AccountPopover />
            <Box sx={{ ml: 2, minWidth: 0 }}>
                <Typography variant="subtitle2" noWrap>
                    {user?.name} {user?.surname}
                </Typography>

                <Typography
                    variant="body2"
                    noWrap
                    sx={{ color: 'text.secondary' }}
                >
                    {user?.email}
                </Typography>
                <Typography
                    variant="body2"
                    noWrap
                    sx={{ color: 'text.secondary' }}
                >
                    {user?.role}
                </Typography>
            </Box>
        </StyledRoot>
    );
}
